export default "__VITE_ASSET__d4627c14__"